import Vue from "vue";
import SiteEnum from "../../domain/web/SiteEnum";

export default class PaginaService {
  constructor(resource) {
    this._resource = resource;
  }

  setWebAdmin() {
    Vue.http.options.root = process.env.API_URL;
  }

  getPaginasMenuByPublico(publico) {
    this.setWebAdmin();

    return this._resource
      .get(`web/pagina/menus/by/${publico}/${SiteEnum.INTERNO}`)
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(err.bodyText);
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/domain/web/PaginaService.js